import { render, staticRenderFns } from "./ContactForm.vue?vue&type=template&id=52b9d9aa&"
import script from "./ContactForm.vue.ts?vue&type=script&lang=js&"
export * from "./ContactForm.vue.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ContactForm.vue.json?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CKreatifGit%5CFrigg.Site.KreatifNo%5Csrc%5Ccomponents%5Ccontact-form%5CContactForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports